import {
  Directive,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { SiaI18nService } from '../services/i18n.service';

@Directive({
  selector: '[appI18n]',
  standalone: true,
})
export class SiaI18nDirective implements OnInit, OnDestroy {
  private elem = inject(ElementRef);
  private i18NService = inject(SiaI18nService);

  @HostListener('window:unload')
  ngOnDestroy() {
    this.elem.nativeElement.remove();
  }

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  ngOnInit() {
    let txt: string = this.elem.nativeElement.textContent;
    if (txt) {
      let translation = this.i18NService.translate(txt);
      this.elem.nativeElement.innerText = translation;
      if (translation.startsWith('$$')) {
        this.elem.nativeElement.style.backgroundColor = 'red';
      }
    }
  }
}
